import { NarratorNPC } from '../../../../src/feature/narrator/narrator.model';
import { dialog } from './dialog';

export const hunter: NarratorNPC = {
  id: 'hunter',
  name: 'Hunter',
  dialog: dialog,
};
